import { Component, computed, DOCUMENT, inject } from '@angular/core';
import { Button } from 'primeng/button';
import { LandingOrganizationInactiveService } from './landing-organization-inactive.service';
import { TranslocoPipe } from '@jsverse/transloco';
import { LoggingService } from '../../../core/utils/logging.service';
import { AuthStore } from '../../../core/auth/auth.store';
import { AuthService } from '@auth0/auth0-angular';

@Component({
  selector: 'app-landing-organization-inactive',
  imports: [Button, TranslocoPipe],
  templateUrl: './landing-organization-inactive.component.html',
  styleUrl: './landing-organization-inactive.component.scss',
})
export class LandingOrganizationInactiveComponent {
  //inject
  private readonly landingOrganizationInactiveService = inject(LandingOrganizationInactiveService);
  private readonly loggingService = inject(LoggingService);
  private doc = inject(DOCUMENT);
  private authStore = inject(AuthStore);
  private auth0 = inject(AuthService);

  landingOrganizationInactiveSignal = this.landingOrganizationInactiveService.getLandingOrganizationInactive();

  landingDataComputed = computed(() => this.landingOrganizationInactiveSignal());

  signOut() {
    this.loggingService.warn('Func | signOut');
    this.authStore.clearState();
    this.auth0.logout({
      logoutParams: {
        returnTo: this.doc.location.origin,
      },
    });
  }
}
